"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { LitElement, html } from "lit";
import { property } from "lit/decorators.js";
import { STCComponentMixin } from "../../../common/mixins/stc_component_mixin";
export class StcFormBuilder extends STCComponentMixin(LitElement) {
  constructor() {
    super(...arguments);
    this.alignment = "stacked";
    this.includeSubmit = false;
    this.includeReset = false;
    this.includeCancel = false;
  }
  render() {
    return html`
      <hi-form id=${this.formId} form=${this.formId} alignment=${this.alignment} column-count=${this.count}>
        <ai-factory-editor
          id="${this.formId}-builder"
          form=${this.formId}
          ?include-submit=${this.includeSubmit}
          ?include-reset=${this.includeReset}
          ?include-cancel=${this.includeCancel}
          submit-label=${this.submitLabel}
          reset-label=${this.resetLabel}
          cancel-label=${this.cancelLabel}
          .type=${this.formType}
        ></ai-factory-editor>
      </hi-form>
    `;
  }
}
__decorateClass([
  property({ type: String, attribute: "form-id" })
], StcFormBuilder.prototype, "formId", 2);
__decorateClass([
  property({ type: String, attribute: "form-alignment" })
], StcFormBuilder.prototype, "alignment", 2);
__decorateClass([
  property({ type: String, attribute: "column-count" })
], StcFormBuilder.prototype, "count", 2);
__decorateClass([
  property({ type: Boolean, attribute: "include-submit" })
], StcFormBuilder.prototype, "includeSubmit", 2);
__decorateClass([
  property({ type: Boolean, attribute: "include-reset" })
], StcFormBuilder.prototype, "includeReset", 2);
__decorateClass([
  property({ type: Boolean, attribute: "include-cancel" })
], StcFormBuilder.prototype, "includeCancel", 2);
__decorateClass([
  property({ type: String, attribute: "submit-label" })
], StcFormBuilder.prototype, "submitLabel", 2);
__decorateClass([
  property({ type: String, attribute: "reset-label" })
], StcFormBuilder.prototype, "resetLabel", 2);
__decorateClass([
  property({ type: String, attribute: "cancel-label" })
], StcFormBuilder.prototype, "cancelLabel", 2);
__decorateClass([
  property({ type: Object, attribute: "form-type" })
], StcFormBuilder.prototype, "formType", 2);
customElements.define("stc-form-builder", StcFormBuilder);
